import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatSidenav } from "@angular/material/sidenav";
import { Event, NavigationEnd, Router } from "@angular/router";
import { AccountService, User } from "@done/ngx-essentials";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { PermissionService } from "../../features/users-roles/services/permission.service";
import { Menu } from "../../shared/models/menu.model";
import { MenuService } from "../../shared/services/menu.service";

@Component({
  selector: "app-default-layout",
  templateUrl: "./default-layout.component.html",
  styleUrls: ["./default-layout.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DefaultLayoutComponent implements OnInit {
  menus: Menu[];
  currentPage: string;
  form: FormGroup;
  areLoggedIn: boolean = false;
  pageIcon: string;
  pageTitle: string;
  hideContainer: boolean = false;
  user: User;
  isValorUp: boolean = false;
  sharedStyle: Object;
  size: number = 26;
  shape: "circle" | "square" = "circle";
  env: "production" | "staging" | "development" = environment.production
    ? "production"
    : environment.staging
      ? "staging"
      : "development";

  @ViewChild("drawer", { static: false }) drawer: MatSidenav;
  @ViewChild("menusList", { static: false }) menusList: ElementRef;

  // Não remover o ISHANDSET ele serve para fazer o colapse do MENU
  isHandset$: Observable<boolean> = this._breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map((result) => result.matches));

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.renderHeight(event.target.innerHeight);
  }

  constructor(
    private _breakpointObserver: BreakpointObserver,
    private _router: Router,
    private _menuService: MenuService,
    private _renderer: Renderer2,
    private _accountService: AccountService,
    private readonly _permissionService: PermissionService,
  ) {}

  ngAfterViewInit(): void {
    this.renderHeight(window.innerHeight);
  }

  async ngOnInit() {
    this.user = await this._accountService.me();
    this.isValorUp = this._accountService.isValorUp;

    this._menuService.hiddenContainer.subscribe(
      (hide: boolean) => (this.hideContainer = hide),
    );
    this._menuService.menuToggled.subscribe(() => this.drawer.toggle());

    this.carregarMenu();

    this.preencherNavBar(this._router.url);

    // Rota inicial
    this.preencherNavBar(location.hash.replace("#", ""));

    this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.preencherNavBar(event.url);
      }
    });

    this._permissionService.init();
  }

  preencherNavBar(rota: string) {
    this.currentPage = rota;

    let menuAtual = this.menus.find(
      (x) => x.url.toLowerCase().indexOf(this.currentPage.toLowerCase()) > -1,
    );

    if (menuAtual) {
      this.pageIcon = menuAtual.icon;
      this.pageTitle = menuAtual.title;
    }
  }

  carregarMenu() {
    this.menus = [];
    // Sempre visível
    this.menus.push(new Menu("/", "Apontamentos", "search"));

    if (this._permissionService.role?.profile === "Admin") {
      this.menus.push(
        new Menu("/tenants-groups", "Grupos econômicos", "domain"),
      );
      this.menus.push(new Menu("/tenants", "Clientes", "business_center"));
      // this.menus.push(new Menu('/users', 'Usuários', 'supervisor_account'));
      this.menus.push(
        new Menu("/monthly-closings", "Fech. mensais", "calendar_today"),
      );
    }

    // Sempre visível
    // this.menus.push(new Menu('/help', 'Help', 'help_outline'));
  }

  isPageActive(url: string): boolean {
    return this.currentPage == null
      ? false
      : this.currentPage.indexOf(url) > -1;
  }

  entrar() {
    this._router.navigate(["/login"]);
  }

  renderHeight(height: number) {
    this._renderer.setStyle(
      this.menusList.nativeElement,
      "height",
      height - 102 + "px",
    );
  }
}
